module.exports = __webpack_public_path__ + "static/media/analytics-icon.cbce7f19.svg";